import React from 'react';
import styles from './styles';

const ThemeStylesContext = React.createContext(styles);

export default ThemeStylesContext;
